import { render, staticRenderFns } from "./PrintableTagDialog.vue?vue&type=template&id=e1b8e33a&scoped=true&"
import script from "./PrintableTagDialog.vue?vue&type=script&lang=js&"
export * from "./PrintableTagDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrintableTagDialog.vue?vue&type=style&index=0&id=e1b8e33a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b8e33a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VList } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VList,VSpacer})
